import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  transform(value: string): any {
    if (!value || value.length !== 10) {
      return value;
    }

    return `+1 (${value.substring(0, 3)}) ${value.substring(3, 6)} ${value.substring(6)}`;
  }
}
